import { Attributes, Rules, Validation, ValueObject } from '@singularsystems/neo-core';
import { Display } from '@singularsystems/neo-core/dist/Model/Decorators';
import { FieldSetting } from './FieldSetting';
import { MandatoryAndVisibleSetting, VisibleSetting } from './FieldSetting.enum';
import IInvestmentFields from './IInvestmentFields';

export default class InvestorInvestmentFieldConfig extends ValueObject implements IInvestmentFields {

    constructor() {
        super();
        this.makeObservable();
    }

    // Details Tab
    
    @Display("Branch")
    public branchId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Commission Type")
    public commissionTypeId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Ceded/Ceded Reason")
    @FieldSetting(VisibleSetting)
    public isCeded: VisibleSetting = VisibleSetting.Visible;

    public termsAcceptedDate: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public contributionDate: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Notice Period")
    public noticePeriodId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public rollingNotice: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public qualifyingPurpose: VisibleSetting = VisibleSetting.Visible;

    public ledgerCode: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public sapGlCode: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public businessUnitNo: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(String)
    @Rules.StringLength(50)
    public businessUnitNoLabel: string = "";

    public areaCode: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public certificateNo: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    public distinctiveNo: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Product Type")
    public productTypeId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public liquidityLadder: VisibleSetting = VisibleSetting.Visible;

    // Investment Tab

    @Display("Initial End Date")
    public initialEndDate: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Payment Date Convention")
    @FieldSetting(VisibleSetting)
    public paymentDateConvention: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public paymentDateOffset: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public completeDividendCycle: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public reinvestDividends: VisibleSetting = VisibleSetting.Visible;

    @Display("Compounding Cycle")
    public compoundingCycleId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public compoundOnDividend: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public compoundOnRateChange: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public endOfMonthReporting: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public rateGrossedUp: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public equityUpside: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public capacityWarehouse: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public parValuePerShare: VisibleSetting = VisibleSetting.Hidden;

    @FieldSetting(VisibleSetting)
    public premiumPerShare: VisibleSetting = VisibleSetting.Hidden;

    @Display("Share Type")
    public shareTypeId: MandatoryAndVisibleSetting = MandatoryAndVisibleSetting.Visible;

    @Display("Is NPV?")
    @FieldSetting(VisibleSetting)
    public isNpv: VisibleSetting = VisibleSetting.Visible;

    @FieldSetting(VisibleSetting)
    public originalBalance: VisibleSetting = VisibleSetting.Visible;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Investor Investment Fields Config";
    }
}